<template>
  <div>
    <div>
      <button
        v-on:click="abrirModalRegistrar()"
        class="btn btn-primary mb-3 btn-sm"
      >
        <span class="svg-icon svg-icon-light svg-icon-1x"
          ><!--begin::Svg Icon | path:C:\wamp64\www\keenthemes\themes\metronic\theme\html\demo2\dist/../src/media/svg/icons\Communication\Add-user.svg--><svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <polygon points="0 0 24 0 24 24 0 24" />
              <path
                d="M18,8 L16,8 C15.4477153,8 15,7.55228475 15,7 C15,6.44771525 15.4477153,6 16,6 L18,6 L18,4 C18,3.44771525 18.4477153,3 19,3 C19.5522847,3 20,3.44771525 20,4 L20,6 L22,6 C22.5522847,6 23,6.44771525 23,7 C23,7.55228475 22.5522847,8 22,8 L20,8 L20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 L18,8 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
                fill="#000000"
                fill-rule="nonzero"
                opacity="0.3"
              />
              <path
                d="M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
                fill="#000000"
                fill-rule="nonzero"
              />
            </g></svg>
          ><!--end::Svg Icon--></span
        >

        Nuevo Usuario
      </button>
      <v-data-table
        :headers="headers"
        :items="usuarios"
        :items-per-page="10"
        class="elevation-2 tabla-codebase theme--light"
        loading-text="Cargando... Espere Por favor"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Registros por página',
          'items-per-page-all-text': 'Todas',
        }"
      >
        <template v-slot:[`item.rutUsuario`]="item">
          <div>
            <div class="symbol symbol-50 symbol-light mr-2" style="float: left">
              <span class="symbol-label">
                <inline-svg
                  src="media/svg/avatars/006-girl-3.svg"
                  class="h-50 align-self-center"
                />
              </span>
            </div>
            <div>
              <span
                class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
              >
                {{ item.item.nombres }}
              </span>
              <div>
                <span class="font-weight-bolder"></span>
                <span class="text-muted font-weight-bold text-hover-primary">
                  {{ item.item.rutUsuario }}-{{ item.item.rutUsuarioDv }}
                </span>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`item.codigoRol`]="item">
          <span
            :class="getColor(item.item.codigoRol)"
            class="label label-md label-inline font-weight-bold"
          >
            {{ capitalizar(item.item.codigoRol) }}</span
          >
        </template>
        <template v-slot:[`item.activo`]="item">
          <span
            :class="getColor(item.item.activo)"
            class="label label-md label-inline font-weight-bold"
          >
            {{ item.item.activo == true ? "Si" : "No" }}</span
          >
        </template>
        <template v-slot:[`item.fechaCreacion`]="item">
          {{ formatDate(item.item.fechaCreacion) }}
        </template>
        <template v-slot:[`item.fechaActualizacion`]="item">
          {{ formatDate(item.item.fechaActualizacion) }}
        </template>

        <template v-slot:[`item.editar`]="item">
          <span
            class="btn btn-icon btn-light btn-hover-primary btn-sm"
            v-on:click="cargarEditarUsuario(item.item)"
          >
            <span class="svg-icon svg-icon-md svg-icon-primary">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Write.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24"></rect>
                  <path
                    d="M12.2674799,18.2323597 L12.0084872,5.45852451 C12.0004303,5.06114792 12.1504154,4.6768183 12.4255037,4.38993949 L15.0030167,1.70195304 L17.5910752,4.40093695 C17.8599071,4.6812911 18.0095067,5.05499603 18.0083938,5.44341307 L17.9718262,18.2062508 C17.9694575,19.0329966 17.2985816,19.701953 16.4718324,19.701953 L13.7671717,19.701953 C12.9505952,19.701953 12.2840328,19.0487684 12.2674799,18.2323597 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                    transform="translate(14.701953, 10.701953) rotate(-135.000000) translate(-14.701953, -10.701953)"
                  ></path>
                  <path
                    d="M12.9,2 C13.4522847,2 13.9,2.44771525 13.9,3 C13.9,3.55228475 13.4522847,4 12.9,4 L6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 L12.9,2 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                    opacity="0.3"
                  ></path>
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
          </span>
        </template>
        <template v-slot:[`item.activar`]="item">
          <span
            class="svg-icon svg-icon-primary svg-icon-2x"
            v-if="item.item.activo == false"
            v-on:click="eliminarUsuario(item.item)"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
                <path
                  d="M16.7689447,7.81768175 C17.1457787,7.41393107 17.7785676,7.39211077 18.1823183,7.76894473 C18.5860689,8.1457787 18.6078892,8.77856757 18.2310553,9.18231825 L11.2310553,16.6823183 C10.8654446,17.0740439 10.2560456,17.107974 9.84920863,16.7592566 L6.34920863,13.7592566 C5.92988278,13.3998345 5.88132125,12.7685345 6.2407434,12.3492086 C6.60016555,11.9298828 7.23146553,11.8813212 7.65079137,12.2407434 L10.4229928,14.616916 L16.7689447,7.81768175 Z"
                  fill="#000000"
                  fill-rule="nonzero"
                />
              </g></svg>
          </span>

          <span
            class="svg-icon svg-icon-primary svg-icon-2x"
            v-if="item.item.activo"
            v-on:click="eliminarUsuario(item.item)"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24" />
                <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
                <path
                  d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z"
                  fill="#000000"
                />
              </g></svg>
            <!--end::Svg Icon--></span
          >
        </template>
        <template v-slot:body.prepend>
        <tr>
          <td>
            <v-text-field
              v-model="rutUsuario"
              type="text"
              label="Rut Usuario"
              prepend-inner-icon="mdi-account-box-multiple"
              outlined
              dense
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              v-model="email"
              type="text"
              label="Email"
              prepend-inner-icon="mdi-account-box-multiple"
              outlined
              dense
            >
            </v-text-field>
          </td>
          <td>
            <v-text-field
              v-model="codigoRol"
              type="text"
              label="Rol"
              prepend-inner-icon="mdi-account-box-multiple"
              outlined
              dense
            >
            </v-text-field>
          </td>
           <!-- <td>
            <v-text-field
              v-model="apellidos"
              type="text"
              label="Apellido"
              prepend-inner-icon="mdi-account-box-multiple"
              outlined
              dense
            ></v-text-field>
          </td> -->
           </tr>
          </template>
      </v-data-table>
    </div>

    <b-modal no-close-on-backdrop id="modal-registrar-usuario" hide-footer>
      <b-form
        @show="resetModal"
        @hidden="resetModal"
        class="form-signin d-flex align-items-stretch flex-column"
        @submit.stop.prevent="onSubmit"
      >
        <div class="text-center mb-2">
          <img
            class="mb-2"
            src="media/logos/logo-contempora1.png"
            alt=""
            width="120"
          />
          <h3 class="mb-0">{{ formTitle }}</h3>
          <span>Completa el siguiente formulario</span>
        </div>

        <div
          role="alert"
          v-show="errors.length > 0"
          v-bind:class="{ show: errors.length }"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <div class="form-label-group">
          <label for="rutUsuario">Rut Usuario</label>

          <b-form-input
            maxlength="8"
            class="form-control"
            id="rutUsuario"
            name="rutUsuario"
            v-model="$v.form.rutUsuario.$model"
            v-on:input="calcularDvRut($v.form.rutUsuario.$model)"
            :state="validateStateFull('rutUsuario')"
            aria-describedby="input-rut-live-feedback"
            placeholder="11111111-1"
            autofocus
            :disabled="esEditarUsuario"
          ></b-form-input>
          <b-form-input
            class="form-control form-control-solid h-auto py-3 px-6"
            id="rutUsuarioDv"
            name="rutUsuarioDv"
            v-model="$v.form.rutUsuarioDv.$model"
            placeholder=""
            disabled=""
          ></b-form-input>
          <b-form-invalid-feedback id="input-rut-live-feedback">
            Rut es obligatorio, máximo 8 dígitos Ej: 12345678
          </b-form-invalid-feedback>
        </div>
        <div class="form-label-group">
          <label for="example-input-3">Nombres</label>

          <b-form-input
            v-on:keypress="validarNombres($event)"
            maxlength="200"
            class="form-control"
            type="text"
            id="example-input-3"
            name="example-input-3"
            v-model="$v.form.nombres.$model"
            :state="validateStateFull('nombres')"
            aria-describedby="input-3-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-3-live-feedback">
            Nombre es requerido.
          </b-form-invalid-feedback>
        </div>

        <!-- <div class="form-label-group">
          <label for="example-input-4">Apellidos</label>

          <b-form-input
            v-on:keypress="validarNombres($event)"
            maxlength="50"
            class="form-control"
            type="text"
            id="example-input-4"
            name="example-input-4"
            v-model="$v.form.apellidos.$model"
            :state="validateStateFull('apellidos')"
            aria-describedby="input-4-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-4-live-feedback">
            Apellidos es requerido.
          </b-form-invalid-feedback>
        </div> -->
        <!-- <div class="form-label-group">
          <label for="example-input-4">Alias</label>

          <b-form-input
            v-on:keypress="validarAlias($event)"
            maxlength="50"
            class="form-control"
            type="text"
            id="example-input-4"
            name="example-input-4"
            v-model="$v.form.alias.$model"
            :state="validateStateFull('alias')"
            aria-describedby="input-4-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-4-live-feedback">
            Alias es requerido.
          </b-form-invalid-feedback>
        </div> -->

        <div class="form-label-group">
          <label for="example-input-5">Email</label>
          <b-form-input
            maxlength="80"
            class="form-control"
            type="email"
            id="example-input-5"
            name="example-input-5"
            v-model="$v.form.email.$model"
            :state="validateStateFull('email')"
            aria-describedby="input-5-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-5-live-feedback">
            Email es requerido.
          </b-form-invalid-feedback>
        </div>

        <div class="form-label-group">
          <label for="example-input-4">Teléfono</label>

          <b-form-input
            v-on:keypress="validarTelefono($event)"
            maxlength="9"
            class="form-control"
            type="text"
            id="example-input-4"
            name="example-input-4"
            v-model="$v.form.telefono.$model"
            :state="validateStateFull('telefono')"
            aria-describedby="input-6-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-6-live-feedback">
            Teléfono es requerido.
          </b-form-invalid-feedback>
        </div>

        <div class="form-label-group">
          <label for="example-input-4">Rol</label>

          <v-select
            v-model="$v.form.codigoRol.$model"
            :items="roles"
            item-text="nombre"
            item-value="codigoRol"
            label="Seleccione Rol"
            persistent-hint
            return-object
            single-line
            :rules="[(v) => !!v || 'Gender is required']"
            required
            aria-describedby="input-7-live-feedback"
            class="p-0"
          ></v-select>

          <b-form-invalid-feedback id="input-7-live-feedback">
            Rol es requerido.
          </b-form-invalid-feedback>
        </div>
        <button
          v-show="esEditarUsuario == false"
          ref="btn_registar_usuario"
          class="btn btn-primary align-self-center"
        >
          Registrar
        </button>

        <button
          v-show="esEditarUsuario"
          ref="btn_actualizar_usuario"
          class="btn btn-primary align-self-center"
        >
          Actualizar
        </button>
      </b-form>
    </b-modal>
    <Loader
      v-bind:loading="activo"
      v-bind:text="modalText"
      v-bind:overlay="overlay"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { LOGOUT } from "@/core/services/store/auth.module";
import {
  GET_USERS,
  UPDATE_USER,
  DESACTIVAR_USER,
} from "@/core/services/store/user.module";
import { ACCOUNT_CREATE } from "@/core/services/store/account.module";
import { GET_ROLES } from "@/core/services/store/rol.module";
import { validationMixin } from "vuelidate";
import {
  email,
  minLength,
  maxLength,
  required,
} from "vuelidate/lib/validators";
import DataTableWidget from "@/view/content/widgets/advance-table/DataTableUsuario.vue";
import moment from "moment";
import Loader from "@/view/content/Loader.vue";
import { rutEsValido, calculateDV } from "@/assets/js/rut.js";
moment.locale("es");

export default {
  mixins: [validationMixin],
  name: "usuarios",
  components: {
    Loader,
  },
  data() {
    return {
      errors : [],
      rutValido:false,
      rutUsuario:"",
      email : "",
      codigoRol:"",
      search: "",
      editedIndex: -1,
      activo: true,
      overlay: true,
      dialog: false,
      usuarios: [],
      roles: [],
      page: 1,
      itemsPerPage: 10,
      pages: 1,
      loading: true,
      esEditarUsuario: false,
      tokenUsuario: null,
      modalText: "Cargando datos...",
      textDatos: "Datos cargados correctamente",
      textErrorDatos: "¡Error al cargar datos!",
      headers: [
        {
          text: "Rut",
          align: "start",
          sortable: true,
          value: "rutUsuario",
          width: "310px",
          filter: (f) => {
            return (f + "")
              .toLowerCase()
              .includes(this["rutUsuario"].toLowerCase());
          },
        },
        // { text: "Nombres", value: "nombres", width: "180px" },
        // { text: "Apellidos", value: "apellidos", width: "180px", filter: (f) => {
        //     return (f + "")
        //       .toLowerCase()
        //       .includes(this["apellidos"].toLowerCase());
        //   }, },
        // { text: "Alias", value: "alias", width: "120px" },
        { 
          text: "Email", 
          value: "email", 
          width: "250px" ,
          filter: (f) => {
            return (f + "")
              .toLowerCase()
              .includes(this["email"].toLowerCase());
          },
        },
        // { text: "Teléfono", value: "telefono", width: "110px" },
        { 
          text: "Rol",
          value: "codigoRol",
          filter: (f) => {
            return (f + "")
              .toLowerCase()
              .includes(this["codigoRol"].toLowerCase());
          },
       },
        { text: "Fecha Creación", value: "fechaCreacion", width: "150px" },
        {
          text: "Fecha Actualización",
          value: "fechaActualizacion",
          width: "190px",
        },
        { text: "Activo", value: "activo", width: "100px" },
        { text: "Editar", value: "editar", sortable: false, width: "60px" },
        { text: "Activar", value: "activar", sortable: false, width: "60px" },
      ],
      step2: false,
      form: {
        rutEmpresa: "96776000-5",
        rutUsuario: "",
        rutUsuarioDv: "",
        nombres: "",
        // apellidos: "",
        // alias: "",
        email: "",
        telefono: "",
        codigoRol: "",
      },
    };
  },
  validations: {
    form: {
      rutEmpresa: {
        required,
        // rut
      },
      numeroDocumento: {
        required,
        minLength: minLength(3),
      },
    },
    form: {
      rutUsuario: {
        required,
        minLength: minLength(7),
        // rut
      },
      rutUsuarioDv: {
        required,
        // minLength: minLength(7),
      },
      nombres: {
        required,
        minLength: minLength(5),
      },
      // apellidos: {
      //   required,
      //   minLength: minLength(5),
      // },
      // alias: {
      //   required,
      //   minLength: minLength(3),
      //   maxLength: maxLength(50),
      // },
      email: {
        required,
        email,
      },
      telefono: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      codigoRol: {
        required,
      },
    },
  },
  mounted() {
    // this.obtenerRoles();
    this.cargarUsuarios();
  },
  methods: {
    calcularDvRut: function(rut) {
      this.$v.form.rutUsuarioDv.$model = calculateDV(rut);
    },
    abrirModalRegistrar() {
      this.editedIndex = -1;
      (this.esEditarUsuario = false), this.resetModal();
      this.resetForm();
      this.$bvModal.show("modal-registrar-usuario");
      this.dialog = true;
    },
    cargarEditarUsuario(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      //console.log((item);
      this.esEditarUsuario = true;
      this.$v.form.rutUsuario.$model = item.rutUsuario;
      this.$v.form.rutUsuarioDv.$model = item.rutUsuarioDv;
      this.$v.form.nombres.$model = item.nombres;
      // this.$v.form.apellidos.$model = item.apellidos;
      // this.$v.form.alias.$model = item.alias;
      this.$v.form.email.$model = item.email;
      this.$v.form.telefono.$model = item.telefono;
      //console.log(("cargarEditarUsuario", this.$v.form.codigoRol.$model);
      this.$v.form.codigoRol.$model = item.codigoRol;
      this.dialog = true;
      this.$bvModal.show("modal-registrar-usuario");
      this.tokenUsuario = item.tokenUsuario;
    },
    actualizarUsuario() {
      const rutUsuarioDv = calculateDV(this.$v.form.rutUsuario.$model);
      const rutUsuario = parseInt(this.$v.form.rutUsuario.$model);

      const nombres = this.$v.form.nombres.$model;
      // const apellidos = this.$v.form.apellidos.$model;
      // const alias = this.$v.form.alias.$model;
      const email = this.$v.form.email.$model;
      const telefono = parseInt(this.$v.form.telefono.$model);
      let codigoRol = this.$v.form.codigoRol.$model.codigoRol;
      const tokenUsuario = this.tokenUsuario;
      // clear existing errors
      // this.$store.dispatch(LOGOUT);

      if (codigoRol == undefined) {
        codigoRol = this.$v.form.codigoRol.$model;
      }
      //console.log(("actualizarUsuario", codigoRol);
      // set spinner to submit button
      const submitButton = this.$refs["btn_actualizar_usuario"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // send login request
      this.$store
        .dispatch(UPDATE_USER, {
          rutUsuario,
          nombres,
          // apellidos,
          // alias,
          email,
          telefono,
          codigoRol,
          tokenUsuario,
        })
        // go to which page after successfully login
        .then(() => {
          this.obtenerRoles();
          this.cargarUsuarios();
          this.dialog = false;
          this.$bvModal.hide("modal-registrar-usuario");
          this.makeToast(
            false,
            "El usuario se ha actualizado correctamente!!!",
            "Usuario Actuzalizado"
          );
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        })
        .catch(({ response }) => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    makeToast(append = false, texto, titulo) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: "success",
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
    obtenerRoles() {
      this.$store.dispatch(GET_ROLES).then((data) => {
        this.roles = data;
        if (this.roles.length > 0) {
          //this.makeToast(false, this.textDatos, "Aviso", "success");
          this.overlay = false;
          this.activo = false;
        } else if (this.roles.length == 0) {
          this.mensajeFalloLoad();
          this.overlay = false;
          this.activo = false;
        }
      });
    },
    getColor(valor) {
      if (valor == "ADMINISTRADOR") return "label-light-primary";
      else if (valor == "CAJERO") return "label-light-success";
      else if (valor == "EJECUTIVO") return "label-light-info";
      else if (valor == true) return "label-light-success";
      else if (valor == false) return "label-light-danger";
      else return "label-light-success";
    },
    capitalizar(valor) {
      let texto = valor.toLowerCase();
      return texto.charAt(0).toUpperCase() + texto.slice(1);
    },
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },
    cargarUsuarios() {
      this.$store.dispatch(GET_USERS).then((data) => {
        this.usuarios = data;
        this.loading = true;
        if (this.usuarios.length > 0) {
          this.obtenerRoles();
        } else if (this.usuarios.length == 0) {
          this.mensajeFalloLoad();
          this.overlay = false;
          this.activo = false;
        }
      });
    },
    mensajeFalloLoad() {
      this.activo = false;
      this.overlay = false;
      this.makeToast(false, this.textErrorDatos, "Error", "danger");
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateFull(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetModal() {
      this.$v.form.rutUsuario.$model = null;
      this.$v.form.rutUsuarioDv.$model = null;
      this.$v.form.nombres.$model = null;
      // this.$v.form.apellidos.$model = null;
      // this.$v.form.alias.$model = null;
      this.$v.form.email.$model = null;
      this.$v.form.telefono.$model = null;
      this.$v.form.codigoRol.$model = null;
    },
    resetForm() {
      this.form = {
        rutUsuario: null,
        rutUsuarioDv: null,
        nombres: null,
        // apellidos: null,
        // alias: null,
        email: null,
        telefono: null,
        codigoRol: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      if (this.esEditarUsuario) {
        this.actualizarUsuario();
      } else {
        this.crearCuenta();
      }
    },
    crearCuenta() {
      this.esEditarUsuario = false;
      const rutUsuarioDv = calculateDV(this.$v.form.rutUsuario.$model);
      const rutUsuario = this.$v.form.rutUsuario.$model + rutUsuarioDv;
      const nombres = this.$v.form.nombres.$model;
      // const apellidos = this.$v.form.apellidos.$model;
      // const alias = this.$v.form.alias.$model;
      const email = this.$v.form.email.$model;
      const telefono = parseInt(this.$v.form.telefono.$model);
      const codigoRol = this.$v.form.codigoRol.$model.codigoRol;
      // clear existing errors
      // this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["btn_registar_usuario"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // send login request
      this.$store
        .dispatch(ACCOUNT_CREATE, {
          rutUsuario,
          nombres,
          // apellidos,
          // alias,
          email,
          telefono,
          codigoRol,
        })
        // go to which page after successfully login
        .then(() => {
          this.obtenerRoles();
          this.cargarUsuarios();
          this.dialog = false;
          this.$bvModal.hide("modal-registrar-usuario");
          this.makeToast(
            false,
            "El usuario se ha creado correctamente!!!",
            "Usuario Creado"
          );
        });

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
    },
    eliminarUsuario(item) {
      this.tokenUsuario = item.tokenUsuario;
      const activo = item.activo == true ? false : true;

      const tokenUsuario = this.tokenUsuario;
      // send login request
      this.$store
        .dispatch(DESACTIVAR_USER, {
          activo,
          tokenUsuario,
        })
        // go to which page after successfully login
        .then(() => {
          this.obtenerRoles();
          this.cargarUsuarios();
          this.$bvModal.hide("modal-registrar-usuario");
          this.makeToast(
            false,
            "El usuario se ha actualizado correctamente!!!",
            "Usuario Actuzalizado"
          );
        });
    },
    validarRut(rut) {
      let resultado = rutEsValido(rut);
      if (resultado == true) {
        this.rutValido = true;
        this.$v.form.rutUsuario.$invalid = true;
        this.$v.form.rutUsuario.$dirty = true;
        this.$v.form.rutUsuario.$error = true;
        this.$v.form.rutUsuario.$anyError = true;
      } else {
        this.rutValido = false;
        this.$v.form.rutUsuario.$invalid = false;
        this.$v.form.rutUsuario.$dirty = false;
        this.$v.form.rutUsuario.$error = false;
        this.$v.form.rutUsuario.$anyError = false;
      }

      // let char = String.fromCharCode(rut.keyCode);
      // if (/^[0-9Kk]+$/.test(char)) return true;
      // else rut.preventDefault();
    },
    validarNombres(nombres) {
      let char = String.fromCharCode(nombres.keyCode);
      if (/^[A-Za-z' ']+$/.test(char)) return true;
      else nombres.preventDefault();
    },
    // validarAlias(alias) {
    //   let char = String.fromCharCode(alias.keyCode);
    //   if (/^[A-Za-z]+$/.test(char)) return true;
    //   else alias.preventDefault();
    // },
    validarTelefono(telefono) {
      let char = String.fromCharCode(telefono.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else telefono.preventDefault();
    },
  },

  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    // formatTime(value) {
    //     const hora = moment(value).format('HH:mm:ss');
    //     return `${hora}`;
    // }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Registrar Nuevo Usuario"
        : "Editar Usuario";
    },
    ...mapState({
    //  errors: (state) => state.errors,
      // user: state => state.auth.user,
    
    }),
  },
};
</script>
<style>
.v-data-table-header th span {
  font-size: 12px;
}
#modal-registrar-usuario .modal-header {
  border: 0 !important;
}

.tabla-codebase td {
  padding: 0.75rem !important;
  border-bottom: 1px solid #ecf0f3 !important;
}
.tabla-codebase th {
  border-bottom: 1px solid #ecf0f3 !important;
}
.form-signin {
  border: 0 !important;
  box-shadow: none !important;
  border-radius: 0px;
}
.b-form-datepicker {
  min-width: 130px;
}
.b-form-datepicker label {
  padding-bottom: 3px !important;
  padding-top: 6px;
  text-transform: none;
  white-space: nowrap !important;
  font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
  padding: 10px 5px;
}
.d-content-full {
  width: 100%;
}
.v-dialog {
  border-radius: 24px;
}
/* .v-data-footer {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: flex-end !important;
    align-items: center !important;
    font-size: .75rem !important;
    padding: 0 8px !important;
}

.v-data-footer__select {
    display: flex !important;
    align-items: center !important;
    flex: 0 0 0 !important;
    justify-content: flex-end !important;
    white-space: nowrap !important;
} */

/* .svg-icon.svg-icon-md svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
}

.btn-sm, .btn-group-sm > .btn {
    padding: 0.55rem 0.75rem !important;
    font-size: 0.925rem !important;
    line-height: 1.35 !important;
    border-radius: 0.42rem !important;
}

.btn.btn-light {
    color: #80808F !important;
    background-color: #F3F6F9 !important;
    border-color: #F3F6F9 !important;
} */
#rutUsuario,
.rut {
  width: 86%;
  float: left;
  margin-right: 6px;
}

#rutUsuarioDv,
.rutDv {
  width: 12%;
}
</style>
